import * as React from "react";

function KnowledFavicon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.05 44.92" transform={'scale(2)'} {...props}>
      <path
        fill={'#fff'}
        fillRule={"evenodd"}
        d="M80.3,44.92h10.24V0h-10.24v44.92h0ZM107.84,0l-17.3,22.46,17.3,22.46h12.21l-17.3-22.46L120.05,0h-12.21Z"
      />
    </svg>
  );
}

export default KnowledFavicon;